import initHeader from "./components/header"

import initProductDetailPage from "./pages/product-detail";
import initHomepage from "./pages/homepage";
import initProductsPage from "./pages/products";

import initFooter from "./components/footer"
import initProductBlock from "./components/product-block"
import initCart from "./pages/cart"

console.log("Custom JS loaded");

const retinaImages = () => {
    const productsDataSrcImages = [...document.querySelectorAll(".products img[data-src]")];

    const replaceAttributeValue = (img, attributeName) => {
        const attributeValue = img.getAttribute(attributeName);
        img.setAttribute(attributeName, attributeValue.replace("/detail/", "/big/"));
    };

    productsDataSrcImages.forEach((img) => {
        replaceAttributeValue(img, "src");
        replaceAttributeValue(img, "data-src");
    });
};

const debugImages = () => {
    const shopImages = document.querySelectorAll("img");
    if (shopImages) {
        shopImages.forEach((image) => {
            const imageSrc = image.getAttribute("src");

            if (imageSrc && !imageSrc.includes("data:")) {
                let srcParametersChar = "?";
                if (imageSrc.includes("?")) {
                    srcParametersChar = "&";
                }
                image.setAttribute(
                    "src",
                    `${imageSrc}${srcParametersChar}v=${Date.now()}`
                );
            }
        });
    }
};

$('.h1.category-title').prependTo('.category-top')

// Init app
window.addEventListener("DOMContentLoaded", () => {
    initHeader();
    retinaImages();
    debugImages();

    initHomepage();
    initProductsPage();
    initProductDetailPage();

    initFooter()
    initProductBlock()
    initCart()
});